/** @jsx jsx */
import { jsx, Box, AspectRatio } from 'theme-ui';

const SectionSized = ({ children, sectionSize, sectionStyles }) => (
  <Box
    as="section"
    sx={{
      ...sectionStyles,
      height: sectionSize === 'viewHeight100' ? sectionSize : 'auto',
      py: sectionSize === 'viewHeight100' ? 0 : sectionSize,
    }}
  >
    {children}
  </Box>
);

const SectionAspect = ({
  aspectHeight,
  aspectWidth,
  children,
  sectionStyles,
}) => (
  <AspectRatio
    as="section"
    ratio={aspectWidth / aspectHeight}
    sx={sectionStyles}
  >
    {children}
  </AspectRatio>
);

const SectionContainer = ({
  aspectHeight,
  aspectWidth,
  backgroundColor,
  backgroundColorOverride,
  children,
  sectionSize,
}) => {
  const sectionStyles = {
    alignContent: 'center',
    alignItems: 'center',
    bg: backgroundColorOverride || backgroundColor,
    display: 'flex',
    justifyContent: 'center',
  };
  return sectionSize === 'aspect' && aspectWidth && aspectHeight ? (
    <SectionAspect
      aspectHeight={aspectHeight}
      aspectWidth={aspectWidth}
      sectionStyles={sectionStyles}
    >
      {children}
    </SectionAspect>
  ) : (
    <SectionSized sectionSize={sectionSize} sectionStyles={sectionStyles}>
      {children}
    </SectionSized>
  );
};

export default SectionContainer;
